﻿const urlParams = new URLSearchParams(window.location.search);
const bookingId = urlParams.get('brn');

$(function () {

    $('#daySelector').on("click", function () {
        var selectedValue = $(this).children("option:selected").val();
        document.getElementById("hidSelectedDay").value = selectedValue
        getPaymentSchedule(bookingId, selectedValue);
        $('#schedule').css('display', 'flex');
    });

    function getPaymentSchedule(bookingID, dayOfMonth) {
        const url = `/feeds/paymentScheduleFeed.aspx?bookingID=${bookingID}&dayOfMonth=${dayOfMonth}`;

        $.ajax({
            url: url,
            dataType: "json",
            success: function (json) {
                updateUI(json);
            }
        });
    };

    function updateUI(data) {
        if (data.Table != null) {
            let lastRowIndex = data.Table.length - 1;
            let finalPayment = data.Table[lastRowIndex].Amount;

            // Filter the table to only include rows with PaymentId as null
            let filteredTable = [];

            for (let i = 0; i < data.Table.length; i++) {
                if (data.Table[i].PaymentId === null) {
                    filteredTable.push(data.Table[i]);
                }
            }

            let noOfPayments = filteredTable.length;
            let monthlyPayments = filteredTable[0].Amount;

            const paymentSummary = $('#paymentSummary');

            // Check if paymentSummary exists on the page
            if (paymentSummary) {
                if (monthlyPayments === finalPayment) {
                    paymentSummary.text(`You will be charged ${formatCurrency(monthlyPayments)} for ${noOfPayments} months.`);
                } else {
                    noOfPayments--; // Remove the final payment from the count
                    paymentSummary.text(`You will be charged ${formatCurrency(monthlyPayments)} for ${noOfPayments} months and then a final payment of ${formatCurrency(finalPayment)}.`);
                }
            }
        }
    };

    if ($('#pnlPaymentSchedule').is("div,ul,blockquote")) {
        getPaymentSchedule(bookingId, 1);
    };

    // Function to format number as currency
    function formatCurrency(amount) {
        return Number(amount).toLocaleString('en-GB', {
            style: 'currency',
            currency: 'GBP'
        });
    };
});

